const DEFAULT_HEIGHT = 350;
const DEFAULT_WIDTH = 225;

export {
    DEFAULT_HEIGHT,
    DEFAULT_WIDTH
}